module.exports = __webpack_public_path__ + "img/wfmh.1f1b9144.png";